import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { AccountAdobeManagedDetails, AccountPromotionalBannerOptOut } from '../../types/generated/Account.schema';
import { IsUploadLinksFeatureDisabledForAccount, IsMountedStorageFeatureDisabledForAccount, IsTranscriptionFeatureDisabledForAccount, CanViewAllUsersPermissionForAccount, CanManageResourceControlPoliciesForAccount, CanManageBillingPermissionForAccount, CanManageAllPermissionForAccount, CanAssignAdminPermissionForAccount } from '../../../features/permissions/queries/generated/fragments';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAccountPermissionsQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type GetAccountPermissionsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, promotionalBannerOptOut?: boolean | null, managedBy?: Types.AccountManagementTypes | null, adobeOrg?: string | null, permissions?: { __typename?: 'AccountPermissions', canAssignAdmin: boolean, canManageAll: boolean, canManageBilling: boolean, canManageResourceControlPolicies: boolean, canViewAllUsers: boolean } | null, disabledFeatures?: { __typename?: 'DisabledFeatures', transcription: boolean, mountedStorage: boolean, uploadLinks: boolean } | null } | null };


export const GetAccountPermissions = /*#__PURE__*/ gql`
    query GetAccountPermissions($accountId: ID!) {
  account(accountId: $accountId) {
    id
    ...AccountPromotionalBannerOptOut
    ...AccountAdobeManagedDetails
    ...CanAssignAdminPermissionForAccount
    ...CanManageAllPermissionForAccount
    ...CanManageBillingPermissionForAccount
    ...CanManageResourceControlPoliciesForAccount
    ...CanViewAllUsersPermissionForAccount
    ...IsTranscriptionFeatureDisabledForAccount
    ...IsMountedStorageFeatureDisabledForAccount
    ...IsUploadLinksFeatureDisabledForAccount
  }
}
    ${AccountPromotionalBannerOptOut}
${AccountAdobeManagedDetails}
${CanAssignAdminPermissionForAccount}
${CanManageAllPermissionForAccount}
${CanManageBillingPermissionForAccount}
${CanManageResourceControlPoliciesForAccount}
${CanViewAllUsersPermissionForAccount}
${IsTranscriptionFeatureDisabledForAccount}
${IsMountedStorageFeatureDisabledForAccount}
${IsUploadLinksFeatureDisabledForAccount}` as unknown as DocumentNode<GetAccountPermissionsQuery, GetAccountPermissionsQueryVariables>;

          

          export const useGetAccountPermissionsQuery = (options?:QueryHookOptions<GetAccountPermissionsQuery, GetAccountPermissionsQueryVariables>) => useQuery(GetAccountPermissions, options);

          

          export type GetAccountPermissionsQueryOptions = QueryHookOptions<GetAccountPermissionsQuery, GetAccountPermissionsQueryVariables>;

          

          export const useGetAccountPermissionsLazyQuery = (options?:LazyQueryHookOptions<GetAccountPermissionsQuery, GetAccountPermissionsQueryVariables>) => useLazyQuery(GetAccountPermissions, options);

          

          export type GetAccountPermissionsQueryResult = ReturnType<typeof useGetAccountPermissionsQuery>;

          
